import React from "react";

export default function UserDetailModal({ show, onClose, asesor, data }) {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-6">

                {/* Header */}
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h2 className="text-xl font-semibold">
                        Detalle por sede – {asesor?.fullName}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800"
                    >
                        ✕
                    </button>
                </div>

                {/* Table */}
                <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 text-sm text-gray-700">
                                <th className="p-2 text-left">Sede</th>
                                <th className="p-2 text-center">Registros</th>
                                <th className="p-2 text-right">Equipos (S/.)</th>
                                <th className="p-2 text-right">Efectivo</th>
                                <th className="p-2 text-right">Online</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-gray-500">
                                        No hay datos disponibles.
                                    </td>
                                </tr>
                            )}

                            {data?.map((row, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50">
                                    <td className="p-2">{row.sedeNombre}</td>
                                    <td className="p-2 text-center">{row.totalRegistros}</td>
                                    <td className="p-2 text-right">S/ {Number(row.totalPhones).toLocaleString()}</td>
                                    <td className="p-2 text-right">S/ {Number(row.totalCash).toLocaleString()}</td>
                                    <td className="p-2 text-right">S/ {Number(row.totalOnline).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Footer */}
                <div className="flex justify-end mt-6">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}
